import { createAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import ApiService from "../../../services/ApiService";
import { startFetching, setLogs, setErrors, setDates } from "../../reducers/ExpLogReducer";

export const fetchPendingDates = createAction("experienceLog/fetchPendingDates");

function* fetchData() {
  yield put(startFetching(true))
  try {
    let res = yield call(ApiService.getPendingDates);
    if(res.data.dates)
        yield put(setDates(res.data.dates));
  } catch (error) {
    console.log({ error });
    yield put(setErrors(error))
  }
}

export function* fetchPendingDatesSaga() {
  yield takeLatest(fetchPendingDates, fetchData);
}

